export const CHANGE_TEMP_PASSWORD_ROUTE = 'account/change-temporary-password'
